import { cn } from "@/lib/utils";

export function Card({ className, children, ...props }) {
  return (
    <div
      className={cn(
        "bg-white rounded-[22px] shadow-soft border border-black/[0.04]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className, children }) {
  return (
    <div className={cn("px-[18px] pt-[18px] pb-0", className)}>{children}</div>
  );
}

export function CardContent({ className, children }) {
  return (
    <div className={cn("px-[18px] py-3", className)}>{children}</div>
  );
}

export function CardTitle({ className, children }) {
  return (
    <h3 className={cn("font-black text-sm text-app-text", className)}>
      {children}
    </h3>
  );
}
